import { useTranslation } from 'react-i18next';
import { isPlCountry } from '../helper/tariffHelper';
import './NeedPay.css';
import SolarIcon from 'components/icons/SolarIcon';

const NeedPay = ({ objectLimit = false }: { objectLimit?: boolean }) => {
    const { t } = useTranslation('Tariff');

    return (
        <div className="need-pay">
            <div className="need-pay__icon">
                <SolarIcon name="credit-card" aria-hidden="true" />
            </div>
            <p className="need-pay__lead">{t(objectLimit ? 'objectLimitText' : 'needPayText')}</p>
            <p className="need-pay__hint">{t(isPlCountry() ? 'needPayHintPl' : 'needPayHint')}</p>
        </div>
    );
};

export default NeedPay;
